// management-frontend/src/components/ConfirmationModal/ConfirmService.js

let showConfirmCallback = null;

const ConfirmService = {
  onConfirm: (callback) => {
    showConfirmCallback = callback;
  },
  show: (title, message, onlyAlert) => {
    return new Promise((resolve) => {
      if (showConfirmCallback) {
        showConfirmCallback({ title, message, onlyAlert, resolve });
      }
    });
  },
};

export default ConfirmService;
